module.exports = __webpack_public_path__ + "img/prj021.b5e1c7ab.png";